import React, { useEffect, useRef, useState } from "react";
import {
  TModuleQuiz,
  TQuestion,
} from "../../../entities/Moodle/model/MoodleTypes";
import { Question } from "../../Question";

interface Props {
  module: TModuleQuiz;
}

const QuizModuleWidget = ({ module }: Props) => {
  const [questions, setQuestions] = useState<TQuestion[]>(module.questions);
  const isMounted = useRef(true);

  //   useEffect(() => {
  //     if (isMounted.current) {
  //       setQuestions(module.questions);
  //       isMounted.current = false;
  //     }
  //   }, [module.questions]);

  return (
    <div style={{ marginLeft: 20, marginTop: 15 }}>
      {questions.map((question, index) => {
        return (
          <Question
            setQuestions={setQuestions}
            key={index}
            question={question}
            attempt={module.attempt}
          />
        );
      })}
    </div>
  );
};

export default QuizModuleWidget;
